import React from 'react';
import styled from 'styled-components';
import Chip from './chip';
import I10n from '../features/i10n';
import { answerIsActive } from '../features/screens/licence_selector_screen/utils';

const Container = styled.div``;

const AnswerContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

class LicenceSelectorChip extends React.Component {

  render() {
    const { answer, userAnswers, setAnswer } = this.props;
    const isSelected = userAnswers[answer.criteria] === answer.value;
    const isDisabled = !answerIsActive(answer, userAnswers) && answer.disableOnly;

    return (
      <Container>
        <AnswerContainer>
          <Chip
            key= {answer.key}
            value= {I10n.getOrDefault(`screen.licence_selector.modal.answer.name.${answer.labelKey}`, answer.name)}
            disabled={isDisabled}
            onClick={() => {
              const isSelected = userAnswers[answer.criteria] === answer.value;
              if (isSelected) {
                setAnswer(answer.criteria, null);
              } else {
                setAnswer(answer.criteria, answer.value);
              }
            }}
            selected={isSelected}
          />
        </AnswerContainer>
      </Container>
    );
  }
}

export default LicenceSelectorChip;
